import { newModal } from "@js/helpers/state.js";
import { CE_MODAL_INSERT_CUSTOM_FIELD_OPEN } from "@js/actions/studio/campaign_content_section/modal_insert_custom_field.js";

export default (state = {}, action) => {
  switch (action.type) {
    case CE_MODAL_INSERT_CUSTOM_FIELD_OPEN:
      return newModal(state, "insert_custom_field", {
        available_fields: state.library.available_fields,
      });

    default:
      return state;
  }
};
